/**
 * Contextual Greeting JavaScript
 * Handles client-side processing of greeting placeholders
 */

(function($) {
    'use strict';

    /**
     * Get time-based greeting
     * @param {number} hour Optional hour (0-23), defaults to current hour
     * @return {string} Greeting based on time of day
     */
    function getTimeBasedGreeting(hour = null) {
        if (hour === null) {
            hour = new Date().getHours();
        }
        
        if (hour >= 5 && hour < 12) {
            return 'Good morning';
        } else if (hour >= 12 && hour < 17) {
            return 'Good afternoon';
        } else if (hour >= 17 && hour < 22) {
            return 'Good evening';
        } else {
            return 'Good evening'; // Late night
        }
    }

    /**
     * Get user name from localStorage and convert to camelCase
     * @return {string} User name in camelCase or empty string if not logged in
     */
    function getUserName() {
        let user_name = '';
        
        // Try to get user data from localStorage (same as navigation)
        if (typeof window.awGetUserData === 'function') {
            const user_data = window.awGetUserData();
            console.log('Contextual Greeting Debug - User data:', user_data);
            
            if (user_data && user_data.f_name && user_data.f_name.trim() !== '') {
                user_name = user_data.f_name;
                console.log('Contextual Greeting Debug - Found user name:', user_name);
            } else {
                console.log('Contextual Greeting Debug - No user name found in user_data');
            }
        } else {
            console.log('Contextual Greeting Debug - awGetUserData function not available');
        }
        
        // Convert to camelCase if we have a name
        if (user_name) {
            user_name = user_name.charAt(0).toUpperCase() + user_name.slice(1).toLowerCase();
            console.log('Contextual Greeting Debug - Formatted user name:', user_name);
        }
        
        return user_name;
    }

    /**
     * Process greeting placeholders in content
     * @param {string} content The content to process
     * @return {string} Processed content
     */
    function processGreetingPlaceholders(content) {
        if (!content) {
            return content;
        }
        
        const greeting = getTimeBasedGreeting();
        const user_name = getUserName();
        
        console.log('Contextual Greeting Debug - Processing content with greeting:', greeting, 'and user_name:', user_name);
        
        // Replace {{{contextualGreeting}}} with greeting + name if logged in, or just greeting if not
        let contextual_greeting = '';
        if (user_name) {
            // Create a styled link for the user name with exclamation point
            const nameLink = `<a href="/user-profile-settings/" style="color: var(--bs-body-color); font-family: Geist; font-weight: 700; font-size: inherit; line-height: inherit; letter-spacing: 0; text-decoration: none; display: inline; padding-bottom: 1px; border-bottom: 2px solid #F53C60; background: none; text-transform: none; transition: color 0.2s;">${user_name}!</a>`;
            contextual_greeting = `${greeting}, ${nameLink}`;
        } else {
            contextual_greeting = greeting + '!';
        }
        console.log('Contextual Greeting Debug - Final contextual greeting:', contextual_greeting);
        
        content = content.replace(/\{\{\{contextualGreeting\}\}\}/g, contextual_greeting);
        
        // Replace {{{greeting}}} with time-based greeting
        content = content.replace(/\{\{\{greeting\}\}\}/g, greeting);
        
        // Replace {{{greetingWithName}}} with full greeting including name
        let full_greeting = '';
        if (user_name) {
            // Create a styled link for the user name with exclamation point
            const nameLink = `<a href="/user-profile-settings/" style="color: var(--bs-body-color); font-family: Geist; font-weight: 700; font-size: inherit; line-height: inherit; letter-spacing: 0; text-decoration: none; display: inline; padding-bottom: 1px; border-bottom: 2px solid #F53C60; background: none; text-transform: none; transition: color 0.2s;">${user_name}!</a>`;
            full_greeting = `${greeting}, ${nameLink}`;
        } else {
            full_greeting = greeting + '!';
        }
        content = content.replace(/\{\{\{greetingWithName\}\}\}/g, full_greeting);
        
        // Replace {{{userName}}} with user name (only if user is logged in)
        if (user_name) {
            // Create a styled link for the user name with exclamation point
            const nameLink = `<a href="/user-profile-settings/" style="color: var(--bs-body-color); font-family: Geist; font-weight: 700; font-size: inherit; line-height: inherit; letter-spacing: 0; text-decoration: none; display: inline; padding-bottom: 1px; border-bottom: 2px solid #F53C60; background: none; text-transform: none; transition: color 0.2s;">${user_name}!</a>`;
            content = content.replace(/\{\{\{userName\}\}\}/g, nameLink);
        } else {
            // Remove the placeholder if no user name
            content = content.replace(/\{\{\{userName\}\}\}/g, '');
        }
        
        // Replace {{{greetingOnly}}} with greeting without name
        content = content.replace(/\{\{\{greetingOnly\}\}\}/g, greeting + '!');
        
        return content;
    }

    /**
     * Split text into words and wrap them for streaming animation
     * @param {string} text The text to split
     * @return {string} HTML with wrapped words
     */
    function wrapWordsForStreaming(text) {
        // Create a temporary div to parse HTML properly
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        
        // Get all text nodes and wrap words
        function wrapWordsInNode(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                const words = node.textContent.split(/(\s+)/);
                const fragment = document.createDocumentFragment();
                
                words.forEach(word => {
                    if (word.trim() === '') {
                        // Preserve whitespace
                        fragment.appendChild(document.createTextNode(word));
                    } else {
                        // Wrap word in span
                        const span = document.createElement('span');
                        span.className = 'streaming-word';
                        span.textContent = word;
                        fragment.appendChild(span);
                    }
                });
                
                node.parentNode.replaceChild(fragment, node);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                // Recursively process child nodes
                const childNodes = Array.from(node.childNodes);
                childNodes.forEach(childNode => {
                    wrapWordsInNode(childNode);
                });
            }
        }
        
        // Process all child nodes
        const childNodes = Array.from(tempDiv.childNodes);
        childNodes.forEach(childNode => {
            wrapWordsInNode(childNode);
        });
        
        return tempDiv.innerHTML;
    }

    /**
     * Process all greeting placeholders on the page
     */
    function processAllGreetingPlaceholders() {
        $('.contextual-greeting-wrapper').each(function() {
            const $wrapper = $(this);
            
            // Only process if not already processed
            if ($wrapper.data('greeting-processed') === true) {
                return;
            }
            
            // Get the content and process it
            let content = $wrapper.html();
            content = processGreetingPlaceholders(content);
            
            // Wrap words for streaming animation
            const $tempDiv = $('<div>').html(content);
            const $paragraph = $tempDiv.find('p');
            if ($paragraph.length > 0) {
                $paragraph.html(wrapWordsForStreaming($paragraph.html()));
                content = $tempDiv.html();
            }
            
            // Update the content but DON'T mark as processed yet
            $wrapper.html(content);
            
            console.log('Contextual Greeting Debug - Content processed and wrapped for streaming');
        });
    }

    /**
     * Initialize Intersection Observer for streaming animation
     */
    function initStreamingAnimation() {
        console.log('Contextual Greeting Debug - Initializing streaming animation');
        
        if (!('IntersectionObserver' in window)) {
            console.log('Contextual Greeting Debug - IntersectionObserver not supported, using fallback');
            // Fallback for browsers without Intersection Observer
            $('.contextual-greeting-wrapper[data-greeting-processed="false"]').each(function() {
                const $wrapper = $(this);
                console.log('Contextual Greeting Debug - Starting fallback animation for wrapper');
                animateStreamingText($wrapper);
            });
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const $wrapper = $(entry.target);
                    console.log('Contextual Greeting Debug - Greeting wrapper came into view, starting animation');
                    
                    // Only animate if not already processed
                    if ($wrapper.data('greeting-processed') !== true) {
                        animateStreamingText($wrapper);
                    }
                    
                    // Stop observing once triggered
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.05,
            rootMargin: '100px'
        });

        // Observe all unprocessed greeting wrappers
        const unprocessedWrappers = $('.contextual-greeting-wrapper[data-greeting-processed="false"]');
        console.log('Contextual Greeting Debug - Found', unprocessedWrappers.length, 'unprocessed greeting wrappers');
        
        unprocessedWrappers.each(function() {
            observer.observe(this);
        });
    }

    /**
     * Animate text streaming word by word
     * @param {jQuery} $wrapper The wrapper element
     */
    function animateStreamingText($wrapper) {
        console.log('Contextual Greeting Debug - Starting streaming animation');
        
        const $paragraph = $wrapper.find('p');
        const words = $paragraph.find('.streaming-word');
        
        console.log('Contextual Greeting Debug - Found', words.length, 'words to animate');
        
        let currentWordIndex = 0;
        
        // Add streaming class to start animation
        $wrapper.addClass('streaming');
        
        function revealNextWord() {
            if (currentWordIndex < words.length) {
                const $word = $(words[currentWordIndex]);
                $word.addClass('visible');
                currentWordIndex++;
                
                // Much faster delays: 5ms to 15ms for instant feel
                const delay = Math.random() * 10 + 5;
                setTimeout(revealNextWord, delay);
            } else {
                // Animation complete, mark as processed but keep text visible
                console.log('Contextual Greeting Debug - Animation complete, marking as processed');
                $wrapper.data('greeting-processed', true);
                // Don't remove streaming class - keep text visible
            }
        }
        
        // Start the animation immediately
        setTimeout(revealNextWord, 10); // Reduced from 50ms to 10ms
    }

    /**
     * Initialize the contextual greeting system
     */
    function initContextualGreeting() {
        // Process placeholders when DOM is ready
        $(document).ready(function() {
            console.log('Contextual Greeting Debug - DOM ready, starting initialization');
            
            // Only process on homepage
            if (!document.body.classList.contains('home') && !document.body.classList.contains('page-template-home')) {
                console.log('Contextual Greeting Debug - Not on homepage, skipping initialization');
                return;
            }
            
            // Initial processing
            processAllGreetingPlaceholders();
            
            // Process again after a short delay to ensure user data is loaded
            setTimeout(function() {
                processAllGreetingPlaceholders();
            }, 200);
            
            // Process again after 500ms to catch any late-loaded content
            setTimeout(function() {
                processAllGreetingPlaceholders();
            }, 500);
            
            // Initialize streaming animation
            setTimeout(function() {
                initStreamingAnimation();
                
                // Fallback: if no wrappers are being observed, start animation immediately
                setTimeout(function() {
                    const unprocessedWrappers = $('.contextual-greeting-wrapper[data-greeting-processed="false"]');
                    console.log('Contextual Greeting Debug - Fallback check: found', unprocessedWrappers.length, 'unprocessed wrappers');
                    
                    if (unprocessedWrappers.length > 0) {
                        console.log('Contextual Greeting Debug - Starting fallback animation for all unprocessed wrappers');
                        unprocessedWrappers.each(function() {
                            const $wrapper = $(this);
                            if ($wrapper.data('greeting-processed') !== true) {
                                animateStreamingText($wrapper);
                            }
                        });
                    }
                }, 800);
            }, 300);
        });
        
        // Listen for user login/logout events
        $(document).on('userLoggedIn userLoggedOut', function() {
            // Only process on homepage
            if (!document.body.classList.contains('home') && !document.body.classList.contains('page-template-home')) {
                return;
            }
            
            // Reset processed state and reprocess
            $('.contextual-greeting-wrapper').data('greeting-processed', false);
            setTimeout(function() {
                processAllGreetingPlaceholders();
                initStreamingAnimation();
            }, 100);
        });
    }

    // Initialize when the script loads
    initContextualGreeting();

})(jQuery);

